Apt.fn.extend('profile', {}, {
	/**
	 * Show team members
	 */
	initMembers() {
		const scope = this;
		const $target = $$('profileMembersApp');

		if (! $target.length) {
			return;
		}

		const $container = $$('profileMembers');

		scope.members = Apt.fn.index().init({
			app: 'profileMembers',
			view: 'profile._members',
			resource: 'profiles/' + scope.id + '/members',
			target: $target,
			paginate: true,
			event: false,
			flash: false,
			static: true,
			value: $target.data('value'),
			params: {
				limit: 15
			},
			sorting: {
				'name': 'Alphabetical',
				'-newest': 'Newest'
			}
		}, data => {
			if (
				! data.results ||
				! data.results.length
			) {
				return;
			}

			$container.show();

			if (location.hash === '#members') {
				setTimeout(() => {
					LS.util.setScroll($container);
				});
			}
		});
	}
});